import EcommerceItem from "@/types/gtm/EcommerceItem";
import GTMData from "@/types/gtm/QuoteGtmEvent";

export const defaultQuoteData = {
  event: "ecom_events",
  event_name: "view_item_list",
  step_name: "order confirmation",
  email_address: null,
  phone_number: null,
  first_name: null,
  last_name: null,
  age: null,
  trip_type: "",
  cover_start_date: null,
  cover_end_date: null,
  travel_from: null,
  travel_group_type: null,
  amount_of_cover_medical: "£10m",
  amount_of_cover_cancellation: null,
  amount_of_cover_baggage: null,
  excess: null,
  covid_cover: null,
  legal_protection: null,
  repatriation: null,
  personal_liability: null,
  winter_sports: null,
  travel_disruption: null,
  excess_waiver: null,
  gadget_cover: null,
  car_hire_excess_waiver: null,
  golf_cover: null,
  cruise_cover: null,
  hundred_days_cover: null,
  quote_id: null,
  policy_id: null,
  medical_condition_added: null,
  site_version: "1.5",
  ecommerce: {
    currency: "GBP",
    item_list_id: "recommended_policies",
    item_list_name: "recommended policies",
    items: [] as EcommerceItem[],
  },
} as GTMData;
